import { useSelector } from 'react-redux';

import { PreviewPageType, FormPageTypeEnum } from '@dev/ee-api/ee-api-models';

import { getFormCreatorStore } from '@/store/formCreator/actions';
import { DisplayedScreenEnum } from '../components/FormPageDropdown';

export const usePageTypeValue = (pageTemplateType: PreviewPageType):DisplayedScreenEnum => {
    const { formObject, formPayload } = useSelector(getFormCreatorStore);
    const value = formPayload?.FormPageType ?? formObject?.FormPageType;

    switch (pageTemplateType) {
        case PreviewPageType.ActivationViaEmail:
            if (value?.[0] === FormPageTypeEnum.DefaultDoubleOptInPage) {
                return DisplayedScreenEnum.Defaultpage;
            } else if (value?.[0] === FormPageTypeEnum.LandingPageDoubleOptInPage) {
                return DisplayedScreenEnum.Landingpage;
            }
            return DisplayedScreenEnum.Externalwebsite;
        case PreviewPageType.FormSubmit:
            if (value?.[1] === FormPageTypeEnum.DefaultFormSubmitPage) {
                return DisplayedScreenEnum.Defaultpage;
            } else if (value?.[1] === FormPageTypeEnum.LandingPageFormSubmitPage) {
                return DisplayedScreenEnum.Landingpage
            }
            return DisplayedScreenEnum.Externalwebsite;
        case PreviewPageType.AlreadySubscribed:
            if (value?.[2] === FormPageTypeEnum.DefaultFormSubscribedPage) {
                return DisplayedScreenEnum.Defaultpage;
            } else if (value?.[2] === FormPageTypeEnum.LandingPageFormSubscribedPage) {
                return DisplayedScreenEnum.Landingpage;
            }
            return DisplayedScreenEnum.Externalwebsite;
        default:
            return DisplayedScreenEnum.Defaultpage;
    }
}